export const DOMAIN = 'consentConfigDetails.configuration.palette';
